/*
 * @Date: 2023-02-14 09:56:13
 * @LastEditTime: 2026-01-31 10:00:00
 * @Description: 认证相关API - 同步小程序端功能
 */
import { request } from "@/request/request";

export default {
  // 发送短信验证码
  sendSms(data) {
    return request({
      url: "/auth/sendSms",
      method: "post",
      data,
    });
  },
  // 验证码注册/登录
  codeLogin(data) {
    return request({
      url: "/auth/codeLogin",
      method: "post",
      data,
    });
  },
  // 密码登录
  passwordLogin(data) {
    return request({
      url: "/auth/passwordLogin",
      method: "post",
      data,
    });
  },
  // 用户注册
  register(data) {
    return request({
      url: "/auth/register",
      method: "post",
      data,
    });
  },
  // 校验短信验证码
  checkCode(data) {
    return request({
      url: "/auth/checkCode",
      method: "post",
      data,
    });
  },
};
